import { reportsBehindOrdersConstants } from "_constants";
import { handleError } from "_helpers";
import { reportsBehindOrdersService } from "_services";
import { alertActions } from "./";

export const reportsBehindOrdersActions = {
  getBehindOrders,
  getBehindOrderRules,
  createBehindOrderRules,
  deleteBehindOrderRules,
};

function getBehindOrders() {
  return (dispatch) => {
    dispatch(request());

    reportsBehindOrdersService.getBehindOrders().then(
      (data) => dispatch(success(data)),
      (error) => {
        dispatch(failure());
        dispatch(alertActions.error(handleError(error)?.message || error?.message || error?.toString()));
      }
    );
  };

  function request() {
    return { type: reportsBehindOrdersConstants.GET_REPORTS_BEHIND_ORDERS_REQUEST };
  }
  function success(payload) {
    return { type: reportsBehindOrdersConstants.GET_REPORTS_BEHIND_ORDERS_SUCCESS, payload };
  }
  function failure() {
    return { type: reportsBehindOrdersConstants.GET_REPORTS_BEHIND_ORDERS_FAILURE };
  }
}

function getBehindOrderRules() {
  return (dispatch) => {
    dispatch(request());

    reportsBehindOrdersService.getBehindOrderRules().then(
      (data) => dispatch(success(data)),
      (error) => {
        dispatch(failure());
        dispatch(alertActions.error(handleError(error)?.message || error?.message || error?.toString()));
      }
    );
  };

  function request() {
    return { type: reportsBehindOrdersConstants.GET_REPORTS_BEHIND_ORDER_RULES_REQUEST };
  }
  function success(payload) {
    return { type: reportsBehindOrdersConstants.GET_REPORTS_BEHIND_ORDER_RULES_SUCCESS, payload };
  }
  function failure() {
    return { type: reportsBehindOrdersConstants.GET_REPORTS_BEHIND_ORDER_RULES_FAILURE };
  }
}

function createBehindOrderRules({ update, body, onSuccess }) {
  return (dispatch) => {
    dispatch(request());

    reportsBehindOrdersService.createBehindOrderRules({ body }).then(
      () => {
        dispatch(success());

        if (update) {
          dispatch(alertActions.success("Rule was updated successfully."));
        } else {
          dispatch(alertActions.success("Rule was created successfully."));
        }

        if (onSuccess) {
          onSuccess();
        }
      },
      (error) => {
        dispatch(failure());
        dispatch(alertActions.error(handleError(error)?.message || error?.message || error?.toString()));
      }
    );
  };

  function request() {
    return { type: reportsBehindOrdersConstants.POST_REPORTS_BEHIND_ORDER_RULES_REQUEST };
  }
  function success() {
    return { type: reportsBehindOrdersConstants.POST_REPORTS_BEHIND_ORDER_RULES_SUCCESS };
  }
  function failure() {
    return { type: reportsBehindOrdersConstants.POST_REPORTS_BEHIND_ORDER_RULES_FAILURE };
  }
}

function deleteBehindOrderRules({ id, onSuccess }) {
  return (dispatch) => {
    dispatch(request());

    reportsBehindOrdersService.deleteBehindOrderRules({ id }).then(
      () => {
        dispatch(alertActions.success("Rule was deleted successfully."));
        dispatch(success());

        if (onSuccess) {
          onSuccess();
        }
      },
      (error) => {
        dispatch(failure());
        dispatch(alertActions.error(handleError(error)?.message || error?.message || error?.toString()));
      }
    );
  };

  function request() {
    return { type: reportsBehindOrdersConstants.DELETE_REPORTS_BEHIND_ORDER_RULES_REQUEST };
  }
  function success() {
    return { type: reportsBehindOrdersConstants.DELETE_REPORTS_BEHIND_ORDER_RULES_SUCCESS };
  }
  function failure() {
    return { type: reportsBehindOrdersConstants.DELETE_REPORTS_BEHIND_ORDER_RULES_FAILURE };
  }
}
